import { z } from "zod";
import { isEmail } from "validator";

export const LoginSchema = z.object({
	email: z.string().refine(data => isEmail(data), "Invalid Email!"),
	password: z.string().min(1, "This field is required!"),
});
